import { Box, Button, Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useCommunityOptOut } from '../hook/useCommunityOptOut';
import {
  LoadingIndicator,
  ImageWithLoader,
  METRICS_COMMUNITY_WITHDRAW,
  METRICS_COMMUNITY_WITHDRAW_CANCEL,
  useAnalytics,
} from '@xolv-mybrightlink/common';

type CommunityWithdrawProps = {
  onBack: () => void;
  onWithdrawn: () => void;
};

export const CommunityWithdraw = (props: CommunityWithdrawProps) => {
  const { onBack, onWithdrawn } = props;
  const optOut = useCommunityOptOut();
  const analytics = useAnalytics();
  const [loading, setLoading] = useState(false);

  const withdraw = useCallback(async () => {
    setLoading(true);
    await optOut();
    analytics.trackAction(METRICS_COMMUNITY_WITHDRAW);
    onWithdrawn();
    setLoading(false);
  }, [optOut, onWithdrawn, analytics]);

  const back = useCallback(() => {
    analytics.trackAction(METRICS_COMMUNITY_WITHDRAW_CANCEL);
    onBack();
  }, [onBack, analytics]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        bgcolor: '#f7f8fb',
        height: '100%',
      }}
    >
      <ImageWithLoader
        src='/public/assets/images/illustration_withdraw.svg'
        style={{
          width: '100%',
          objectFit: 'contain',
        }}
        loaderSxProps={{ minHeight: 200 }}
      />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          px: '15%',
          height: '100%',
        }}
      >
        <Typography sx={{ mb: 5, alignSelf: 'flex-start' }}>
          <FormattedMessage id='community.withdraw.message' />
        </Typography>
        {!loading && (
          <Box
            sx={{
              mt: 'auto',
              mb: 10,
              width: '100%',
              display: 'flex',
              fontSize: 16,
            }}
          >
            <Button
              variant='outlined'
              color='inherit'
              onClick={back}
              sx={{ borderRadius: 8, width: '100%', px: 4, mr: 15, py: 4 }}
            >
              <Typography sx={{ fontWeight: 500 }}>
                <FormattedMessage id='common.go-back' />
              </Typography>
            </Button>
            <Button
              variant='contained'
              color='secondary'
              onClick={withdraw}
              sx={{
                borderRadius: 8,
                width: '100%',
                ml: 4,
                px: 11,
                py: 4,
                boxShadow: 'none',
              }}
            >
              <Typography sx={{ fontWeight: 500 }}>
                <FormattedMessage id='community.withdraw.leave' />
              </Typography>
            </Button>
          </Box>
        )}
        {loading && <LoadingIndicator fullHeight />}
      </Box>
    </Box>
  );
};
